import { useEffect, useState } from 'react';

export const useFetch = <T>(
    fetcher: () => Promise<T>
): {
    data: T | null;
    error: Error | null;
    loading: boolean;
} => {
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState<Error | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            setLoading(true);
            setError(null);
            try {
                const result = await fetcher();
                if (!cancelled) {
                    setData(result);
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err as Error);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        run();

        return () => {
            cancelled = true;
        };
    }, [fetcher]);

    return { data, error, loading };
};
